<div style="display: flex; max-height: 100vh">
  <div style="display: flex; flex-direction: column; flex: 1vh">
    <div style="display: flex; flex-direction: row; flex: 100vh">
      <div style="display: flex; flex-direction:column; flex: 0 50vw; align-items: center;">
        <div class="m-auto w-50 verification-card">
          <div class="d-flex flex-column justify-content-center align-items-center">
            <h2 class="verification-title">Two Factor Authentication</h2>
            <p class="verification-subtitle">Your 2FA OTP has been sent to your {{ isTfaPhoneVerified ? 'mobile number' : 'email' }}</p>
          </div>
          
          <!-- Custom verification code input styling around the dynamic form -->
          <div class="verification-form-wrapper">
            <dynamic-form #dynamicForm [model]="form" (clickSubmit)="verifyOtp($event)" [loading]="isLoading">
            </dynamic-form>
            
            <div class="verification-actions">
              <div class="resend-text">
                <span *ngIf="!resendDisabled">Didn't receive OTP? </span>
                <a href="#" (click)="resendOtp(); $event.preventDefault()" [class.disabled]="resendDisabled || isLoading" class="resend-link">
                  {{ resendDisabled ? 'Resend OTP in ' + countdown + 's' : 'Resend OTP' }}
                </a>
              </div>
              
              <button (click)="verifyCode()" [disabled]="isLoading" class="verify-button">
                <span *ngIf="!isLoading">Verify</span>
                <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="login-hero">
        <div class="login-hero-text">
          Join the most satisfied auto transport customers in the country.
        </div>
      </div>
    </div>
  </div>
</div>